import { render, staticRenderFns } from "./CurrentIntegration.vue?vue&type=template&id=f5b335fc"
import script from "./CurrentIntegration.vue?vue&type=script&lang=js"
export * from "./CurrentIntegration.vue?vue&type=script&lang=js"
import style0 from "./CurrentIntegration.vue?vue&type=style&index=0&id=f5b335fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports